export default "__VITE_ASSET__570ddd99__"